import { render, staticRenderFns } from "./emissionsCarbon.vue?vue&type=template&id=250db116&scoped=true"
import script from "./emissionsCarbon.vue?vue&type=script&lang=js"
export * from "./emissionsCarbon.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=250db116&prod&scoped=true&lang=css&external"
import style1 from "./emissionsCarbon.vue?vue&type=style&index=1&id=250db116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250db116",
  null
  
)

export default component.exports